import { defineStore } from "pinia";
import { ConversationTypeEnum } from "../../../enums/ConversationTypeEnum";
import { ConversationRoomTypeEnum } from "../../../enums/ConversationRoomTypeEnum";
import { Container } from "aurelia-dependency-injection";
import { MessageService } from "../../../services/message-service";
import { AttendanceTypeEnum } from "../../../enums/AttendanceTypeEnum";
import { jitsiConferenceStatus } from "../../../enums/jitsiConferenceStatus";

interface IStoreOutgoingCallInfo {
    convId: string;
    users: any;
    convType: ConversationTypeEnum;
    roomType: ConversationRoomTypeEnum;
    isRetryCall: boolean;
}

export const useCallStore = defineStore("calls", {
    state: () => ({
        currentCallDetails: {
            convId: null as string,
            isUserOnCall: false as boolean,
            roomId: null as string,
            isFPCall: false as boolean
        },
        showCallHeader: {
            convId: null as string,
            show: false as boolean,
            callStartTime: null as string,
            roomId: null as string
        },
        outgoingCallInfo: {
            convId: "",
            users: [],
            convType: null,
            roomType: ConversationRoomTypeEnum.AudioCall,
            isRetryCall: false
        } as IStoreOutgoingCallInfo
    }),
    actions: {
        setCurrentCallDetails(payload: any) {
            this.currentCallDetails = payload;
        },
        setShowCallHeader(payload: any) {
            this.showCallHeader = payload;
        },

        setOutgoingCallInfo(payload: IStoreOutgoingCallInfo) {
            this.outgoingCallInfo = payload;
        },

        async markAttendanceForUser(
            attendanceType: AttendanceTypeEnum,
            conversationId: string = null,
            roomId: string = null,
            isRetryCall: boolean = false
        ) {
            if (this.currentCallDetails?.isFPCall === true) {
                return;
            }
            const messageService = Container.instance.get(MessageService);

            if (this.currentCallDetails?.roomId && attendanceType === AttendanceTypeEnum.Leave) {
                try {
                    const payload = {
                        roomId: this.currentCallDetails.roomId,
                        attendanceType
                    };
                    await messageService.markCallAttendanceForUser(this.currentCallDetails.convId, payload);
                    this.setCurrentCallDetails({
                        convId: null,
                        roomId: null,
                        isUserOnCall: false,
                        isFPCall: false
                    });
                } catch (error) {
                    console.error("Error marking call attendance for the user", error);
                }
            } else {
                try {
                    const payload = {
                        roomId,
                        attendanceType
                    };
                    if (isRetryCall) {
                        await messageService.markCallAttendanceForUser(this.outgoingCallInfo.convId, payload);
                    } else {
                        await messageService.markCallAttendanceForUser(conversationId, payload);
                    }
                    this.currentCallDetails = {
                        convId: conversationId,
                        isUserOnCall: true,
                        isFPCall: false,
                        roomId: roomId
                    };
                } catch (error) {
                    console.error("Error marking call attendance for the user", error);
                }
            }
        },

        async getConversationRoomStatus(convId: string) {
            try {
                const messageService = Container.instance.get(MessageService);
                const conversationRoomStatus = await messageService.getConversationRoomStatus(convId);
                if (conversationRoomStatus.roomDetails) {
                    if (conversationRoomStatus.roomDetails.roomStatus === jitsiConferenceStatus.Ongoing) {
                        this.showCallHeader = {
                            convId: convId,
                            show: true,
                            roomId: conversationRoomStatus.roomDetails.roomId,
                            callStartTime: conversationRoomStatus.roomDetails.startTime
                        };
                    } else {
                        this.showCallHeader = {
                            convId: null,
                            show: false,
                            roomId: null,
                            callStartTime: null
                        };
                    }
                }
            } catch (error) {
                console.error("Error fetching conversation roomm status", error);
            }
        }
    }
});
